import React from 'react';
import BahlouLogoFull from '@/assets/Bahlou_logo.png';
import { cnMerge } from '@/utils/cnMerge';

export interface LoginV3LayoutProps {
    children: React.ReactNode;
    /** Outer content max width (card lives inside) */
    maxWidthClassName?: string;
    showLogo?: boolean;
    /** Taller scroll area for department / employee lists */
    contentClassName?: string;
}

export default function LoginV3Layout({
    children,
    maxWidthClassName = 'max-w-[480px]',
    showLogo = true,
    contentClassName,
}: LoginV3LayoutProps) {
    return (
        <div className="relative min-h-screen sm:h-screen w-full flex flex-col items-center justify-center bg-[#FDFCFB] overflow-hidden px-4 py-6">
            <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-primary-500/10 blur-3xl hidden sm:block" />
            <div className="absolute -bottom-24 -left-24 w-72 h-72 rounded-full bg-primary-500/10 blur-3xl hidden sm:block" />

            <div
                className={cnMerge(
                    'z-10 w-full flex flex-col justify-center',
                    maxWidthClassName,
                    contentClassName,
                )}
            >
                {showLogo ? (
                    <div className="flex justify-center mb-6 sm:mb-10 flex-shrink-0">
                        <img src={BahlouLogoFull} alt="" className="h-8 sm:h-12 object-contain" />
                    </div>
                ) : null}
                {children}
            </div>
        </div>
    );
}
